import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';

export class InteroperableDataService {
  static async getCountries({ page = 1, search = '' }) {
    const { root, countries } = API.interoperableData;
    const queryParams = { page, search };
    const { data } = await DataService.get(`${root}${countries}`, queryParams);
    return {
      countries: data.countries,
      total: data.total,
      pageSize: data.pageSize,
      search,
      page,
    };
  }

  static async getCities({ page = 1, search = '', stateCode }) {
    const { root, cities } = API.interoperableData;
    const queryParams = { page, search, stateCode };
    const { data } = await DataService.get(`${root}${cities}`, queryParams);
    return {
      cities: data.cities,
      total: data.total,
      pageSize: data.pageSize,
      search,
      page,
    };
  }

  static async getDepartments({ page = 1, search = '' }) {
    const { root, departments } = API.interoperableData;
    const queryParams = { page, search };
    const { data } = await DataService.get(`${root}${departments}`, queryParams);
    return {
      departments: data.departments,
      total: data.total,
      pageSize: data.pageSize,
      search,
      page,
    };
  }

  static async getDocumentTypes({ page = 1, search = '' }) {
    const { root, documentTypes } = API.interoperableData;
    const queryParams = { page, search };
    const { data } = await DataService.get(`${root}${documentTypes}`, queryParams);
    return {
      documentTypes: data.documentTypes,
      total: data.total,
      pageSize: data.pageSize,
      search,
      page,
    };
  }

  static async getPersonConditions({ page = 1, search = '' }) {
    const { root, personConditions } = API.interoperableData;
    const queryParams = { page, search };
    const { data } = await DataService.get(`${root}${personConditions}`, queryParams);
    return {
      personConditions: data.personConditions,
      total: data.total,
      pageSize: data.pageSize,
      search,
      page,
    };
  }

  static async getScholarlyLevels({ page = 1, search = '' }) {
    const { root, scholarlyLevels } = API.interoperableData;
    const queryParams = { page, search };
    const { data } = await DataService.get(`${root}${scholarlyLevels}`, queryParams);
    return {
      scholarlyLevels: data.scholarlyLevels,
      total: data.total,
      pageSize: data.pageSize,
      search,
      page,
    };
  }

  static async getBiologicalSexes({ page = 1, search = '' }) {
    const { root, biologicalSexes } = API.interoperableData;
    const queryParams = { page, search };
    const { data } = await DataService.get(`${root}${biologicalSexes}`, queryParams);
    return {
      biologicalSexes: data.biologicalSexes,
      total: data.total,
      pageSize: data.pageSize,
      search,
      page,
    };
  }

  static async getBloodTypes({ page = 1, search = '' }) {
    const { root, bloodTypes } = API.interoperableData;
    const queryParams = { page, search };
    const { data } = await DataService.get(`${root}${bloodTypes}`, queryParams);
    return {
      bloodTypes: data.bloodTypes,
      total: data.total,
      pageSize: data.pageSize,
      search,
      page,
    };
  }

  static async getHealthInsurances({ page = 1, search = '' }) {
    const { root, healthInsurances } = API.interoperableData;
    const queryParams = { page, search };
    const { data } = await DataService.get(`${root}${healthInsurances}`, queryParams);
    return {
      healthInsurances: data.healthInsurances,
      total: data.total,
      pageSize: data.pageSize,
      search,
      page,
    };
  }

  static async getRegimes({ page = 1, search = '' }) {
    const { root, healthInsurances, regimes } = API.interoperableData;
    const queryParams = { page, search };
    const { data } = await DataService.get(`${root}${healthInsurances}/${regimes}`, queryParams);
    return {
      regimes: data.regimes,
      total: data.total,
      pageSize: data.pageSize,
      search,
      page,
    };
  }

}
